import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9bfww6xgxk: FaireBrandEntity = {
  token: "b_9bfww6xgxk",
  type: "brand",
  name: "United Scents",
  avatarUrl:
    "https://cdn.faire.com/fastly/2542b75bed0e167eea93124211e96ca193d1e14d04cd7b0ada4caa0f74560fe7.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5fac1e197c30519aed066a0c96ea3aa4e01a94d6672f0fd2a8a7f89c1b1cc631.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2542b75bed0e167eea93124211e96ca193d1e14d04cd7b0ada4caa0f74560fe7.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5fac1e197c30519aed066a0c96ea3aa4e01a94d6672f0fd2a8a7f89c1b1cc631.png",
  location: "Edison, NJ, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 6,
  isInsider: true,
  description:
    "\nUnited Scents – Where Luxury Becomes Accessible\n\nUnited Scents was created with a simple belief: fragrance is emotion, memory, and identity — and everyone deserves access to scents that feel powerful, refined, and unforgettable. Inspired by the world’s most iconic luxury perfumes, we craft high-quality interpretations that capture the spirit, depth, and sophistication of designer fragrances without the designer price.\n\nEach scent is carefully developed to reflect two essential dimensions: the fragrance profile itself — from warm amber and creamy vanilla to bright citrus, soft florals, and deep woody accords — and the inspiration behind it. We study the structure, balance, and evolution of the world’s most beloved perfumes, then recreate that experience with precision and artistry.\n\nOur formulas are long-lasting, smooth, and designed to project confidence. Whether you prefer bold statement scents or clean everyday freshness, United Scents allows you to build a fragrance wardrobe that matches your mood, your moment, and your ambition.\n\nWe believe luxury should unite people, not divide them. That’s why our mission is simple: premium scent experiences, thoughtfully crafted, beautifully packaged, and accessible to everyone.\n\nUnited Scents — Smell Exceptional. Live United.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:03.719Z",
    importedBy: "entity-db-cli",
  },
};
